module.exports = __webpack_public_path__ + "img/icon-home-ev-02.cf7ace38.jpg";